import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';

import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { NEVER, of } from 'rxjs';
import { UserContactInfo } from '../models/user-contact-info.model';
import { BoardService } from '../services/sections/job/board.service';
import { ContactType } from '../models/enum/contact-type.enum';

@Injectable({
	providedIn: 'root'
})
export class BoardMembersResolver implements Resolve<UserContactInfo[]> {
	constructor(
		private boardService: BoardService,
		private router: Router
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.boardService.getContacts(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.router.navigate(['/404']);
					return NEVER;
				}),
				map(members => members.map(member => {
					const contact = {
						emailAddress: member.email,
						phoneNumber: member.phone,
						firstName: member.firstName,
						lastName: member.lastName,
						contactType: ContactType.BoardMember
					} as UserContactInfo;

					return contact;
				}))
			);
	}
}
